import './styles/app.scss'
import { useState } from 'react'
import ReactGA from 'react-ga'
import Footer from './Footer'

function App() {
    ReactGA.initialize('UA-132563689-5')

    const [view, setView] = useState(false)

    return (
        <div className='App'>
            <div className={`preoder-container ${view && 'visible'}`}>
                <div className='preorder-section'>
                    <h1 className='preorder-title'>The Legend of Heroes: Trails from Zero</h1>
                    <div className='preorder-links zero'>
                        <LinkButton
                            game='Zero'
                            console='PS4™'
                            store='Amazon'
                            link='https://www.amazon.com/Legend-Heroes-Trails-Zero-PlayStation-4/dp/B099TL6FN5'
                        />
                        <LinkButton
                            game='Zero'
                            console='PS4™'
                            store='Amazon (CA)'
                            link='https://www.amazon.ca/Legend-Heroes-Trails-Zero-PlayStation/dp/B099TL6FN5'
                        />
                        <LinkButton
                            game='Zero'
                            console='PS4™'
                            store='GameStop'
                            link='https://www.gamestop.com/video-games/playstation-4/products/the-legend-of-heroes-trails-from-zero---playstation-4/325348.html'
                        />

                        <LinkButton
                            game='Zero'
                            console='PS4™'
                            store='Best Buy'
                            link='https://www.bestbuy.com/site/the-legend-of-heroes-trails-from-zero-playstation-4/6481219.p?skuId=6481219'
                        />
                        <LinkButton
                            game='Zero'
                            console='Nintendo Switch™'
                            store='Amazon'
                            link='https://www.amazon.com/Legend-Heroes-Trails-Zero-Nintendo-Switch/dp/B099TL61TZ/'
                        />
                        <LinkButton
                            game='Zero'
                            console='Nintendo Switch™'
                            store='Amazon (CA)'
                            link='https://www.amazon.ca/Legend-Heroes-Trails-Nintendo-Switch/dp/B099TL61TZ/'
                        />

                        <LinkButton
                            game='Zero'
                            console='Nintendo Switch™'
                            store='BestBuy'
                            link='https://www.bestbuy.com/site/the-legend-of-heroes-trails-from-zero-deluxe-edition-nintendo-switch/6481218.p?skuId=6481218'
                        />

                        <LinkButton
                            game='Zero'
                            console='PC'
                            store='Steam'
                            link='https://store.steampowered.com/app/1668510/The_Legend_of_Heroes_Trails_from_Zero/'
                        />
                        <LinkButton
                            game='Zero'
                            console='PC'
                            store='Epic Games Store'
                            link='https://store.epicgames.com/en-US/p/the-legend-of-heroes-trails-from-zero'
                        />
                        <LinkButton
                            game='Zero'
                            console='PC'
                            store='GOG'
                            link='https://www.gog.com/en/game/the_legend_of_heroes_trails_from_zero'
                        />
                    </div>
                </div>
                <div className='preorder-section'>
                    <h1 className='preorder-title'>The Legend of Heroes: Trails to Azure</h1>
                    <div className='preorder-links azure'>
                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='Amazon'
                            link='https://www.amazon.com/Legend-Heroes-Trails-Azure-Nintendo-Switch/dp/B09B1QVNT6'
                        />
                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='Amazon (CA)'
                            link='https://www.amazon.ca/Legend-Heroes-Trails-Nintendo-Switch/dp/B09B1QVNT6/'
                        />
                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='GameStop'
                            link='https://www.gamestop.com/video-games/products/the-legend-of-heroes-trails-to-azure---nintendo-switch/325358.html?bt=truhttps://www.gamestop.com/video-games/nintendo-switch/products/the-legend-of-heroes-trails-to-azure---nintendo-switch/390871.html'
                        />

                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='Best Buy'
                            link='https://www.bestbuy.com/site/the-legend-of-heroes-trails-to-azure-nintendo-switch/6481233.p?skuId=6481233'
                        />
                        <LinkButton
                            game='Azure'
                            console='Nintendo Switch™'
                            store='Walmart'
                            link='https://www.walmart.com/ip/The-Legend-of-Heroes-Trail-to-Azure-Deluxe-Edition-Nintendo-Switch/901905779'
                        />
                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='Amazon'
                            link='https://www.amazon.com/Legend-Heroes-Trails-Zero-Nintendo-Switch/dp/B099TL61TZ/'
                        />
                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='Amazon (CA)'
                            link='https://www.amazon.ca/Legend-Heroes-Trails-Nintendo-Switch/dp/B099TL61TZ/'
                        />
                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='GameStop'
                            link='https://www.gamestop.com/video-games/products/the-legend-of-heroes-trails-to-azure---playstation-4/325355.html?bt=true'
                        />

                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='BestBuy'
                            link='https://www.bestbuy.com/site/the-legend-of-heroes-trails-to-azure-playstation-4/6481232.p?skuId=6481232'
                        />
                        <LinkButton
                            game='Azure'
                            console='PS4™'
                            store='Walmart'
                            link='https://www.walmart.com/ip/The-Legend-of-Heroes-Trails-to-Azure-Deluxe-Edition-PlayStation-4/613736772'
                        />
                    </div>
                </div>
                <div className='preorder-button'>
                    <button
                        onClick={() => {
                            setView(false)
                        }}
                    >
                        Close
                    </button>
                </div>
            </div>
            <div className='top-bar'>
                <img src='./img/falcom.png' alt='Falcom Logo' />
                <h1>The Legend of Heroes: Trails from Zero &amp; Trails to Azure </h1>
            </div>
            <div className='game-logos'>
                <div className='logo-pair zero'>
                    <img src='./img/zero_logo_rda.png' alt='' />
                    {/* <h1>
                        Coming Fall 2026 to Nintendo Switch™2 and PlayStation®5 <br />Available now on Nintendo Switch™,
                        PlayStation®4, and PC
                    </h1> */}
                    <a
                        href='https://www.thelegendofheroes.com/crossbell/zero/'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <button className='official'>"Trails from Zero" - Official Website</button>
                    </a>
                </div>
                <div className='logo-pair azure'>
                    <img src='./img/azure_logo_rda.png' alt='' />
                    {/* <h1>
                        Coming Fall 2026 to Nintendo Switch™2 and PlayStation®5 <br />Available now on Nintendo Switch™,
                        PlayStation®4, and PC
                    </h1> */}
                    <a
                        href='https://www.thelegendofheroes.com/crossbell/azure/'
                        target='_blank'
                        rel='noopener noreferrer'
                    >
                        <button className='official'>"Trails to Azure" - Official Website</button>
                    </a>
                </div>
            </div>
           
                <div className='video-container'>
                    <div className='video-wrapper'>
                        <div
                            style={{
                                position: 'relative',
                                paddingBottom: '56.25%',
                                height: 0,
                                overflow: 'hidden',
                            }}
                        >
                            <iframe
                                style={{
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                }}
                                src='https://www.youtube.com/embed/XHpTVUikuO0'
                                frameborder='0'
                                allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
                                allowfullscreen
                                title='Release date announcement trailer'
                            ></iframe>
                        </div>
                    </div>
                </div>
          
            <div className='preorder-button'>
                <button
                    onClick={() => {
                        setView(true)
                    }}
                >
                    Buy Now for Nintendo Switch™, PlayStation®4, and PC
                </button>
            </div>
            <div className='specs-container'>
                <div className='spec-wrapper'>
                    <table class='spec-table'>
                        <tbody>
                            <tr>
                                <th>Title</th>
                                <td>The&nbsp;Legend&nbsp;of&nbsp;Heroes:&nbsp;Trails&nbsp;from&nbsp;Zero</td>
                            </tr>
                            <tr>
                                <th>Release</th>
                                <td>
                                    September 10, 2026 (Nintendo Switch™2 and PlayStation®5) <br />
                                    Available now (Nintendo Switch™, PlayStation®4, and PC)
                                </td>
                            </tr>
                            <tr>
                                <th>Platform</th>
                                <td>Nintendo Switch™2, Nintendo Switch™, PlayStation®5, PlayStation®4. PC</td>
                            </tr>
                            <tr>
                                <th>Player(s)</th>
                                <td>1</td>
                            </tr>
                            <tr>
                                <th>Genre</th>
                                <td>RPG</td>
                            </tr>
                            <tr>
                                <th>Audio</th>
                                <td>Japanese</td>
                            </tr>
                            <tr>
                                <th>Text</th>
                                <td>English</td>
                            </tr>
                            <tr>
                                <th>Developer</th>
                                <td>Nihon Falcom</td>
                            </tr>
                            <tr>
                                <th>Publisher</th>
                                <td>NIS America, Inc.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='spec-wrapper'>
                    <table class='spec-table'>
                        <tbody>
                            <tr>
                                <th>Title</th>
                                <td>The Legend of Heroes: Trails to Azure </td>
                            </tr>
                            <tr>
                                <th>Release</th>
                                <td>
                                    September 10, 2026 (Nintendo Switch™2 and PlayStation®5) <br />
                                    Available now (Nintendo Switch™, PlayStation®4, and PC)
                                </td>
                            </tr>
                            <tr>
                                <th>Platform</th>
                                <td>Nintendo Switch™2, Nintendo Switch™, PlayStation®5, PlayStation®4. PC</td>
                            </tr>
                            <tr>
                                <th>Player(s)</th>
                                <td>1</td>
                            </tr>
                            <tr>
                                <th>Genre</th>
                                <td>RPG</td>
                            </tr>
                            <tr>
                                <th>Audio</th>
                                <td>Japanese</td>
                            </tr>
                            <tr>
                                <th>Text</th>
                                <td>English</td>
                            </tr>
                            <tr>
                                <th>Developer</th>
                                <td>Nihon Falcom</td>
                            </tr>
                            <tr>
                                <th>Publisher</th>
                                <td>NIS America, Inc.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <Footer />
        </div>
    )
}

const LinkButton = ({ game, console, store, link }) => (
    <a
        href={link}
        target='_blank'
        rel='noreferrer'
        onClick={() => {
            ReactGA.event({
                category: 'engagement',
                action: 'generate_lead',
                label: `Purchase - ${game} - ${console} - ${store}`,
            })
        }}
    >
        <button>
            {store} <br />
            {console}
        </button>
    </a>
)

export default App
